/* @flow */

import { type ContextRouter } from 'react-router-dom';
import * as React from 'react';

import RankingPage from '../../common/RankingPage';

const IceRankingPage = (props: ContextRouter) => (
  <RankingPage
    kind="ice"
    onNextClick={() => {
      props.history.push('/ice/fields?skip_intro=1');
    }}
  />
);

export default IceRankingPage;
